define(
    'modals/secured/subscription/pricing',[
        "providers/dataprovider",
        "plugins/dialog",
        "i19n!i19n/strings",
        "plugins/router",
        "viewmodels/message"
    ],
    function (dataProvider, dialog, i19n, router, message) {
        var _included_users_ = 2;

        var modal = function Modal() {
            var self = this;

            self.i19n = i19n;
            self.header = ko.observable('Review and Confirm');
            self.paymentUrl= ko.observable('');

            self.plan = {};

            self.closeNotification = function () {
            };
            self.isReviewAndConfirmEnabled = ko.observable(true);
        }
   
        modal.prototype.activate = function (plan) {
            var self = this;            

            self.isReviewAndConfirmEnabled(true);
            self.mode = plan._modal;
            self.plan = plan;
            
            if (self.mode == "trial") {
                self.header('Please wait...');
                var data = {
                    instanceId: window.fileplan.instanceCode,
                    planCode: self.plan.code,
                    additionalUsers: self.plan.peopleInfo - _included_users_
                };

                dataProvider.subscription
                .checkoutSubscription(data)
                .done(function (data) {
                    self.paymentUrl(data.accessUrl);
                    self.header(i19n.to.enterpaymentdetails);
                })
                .fail(function (e) {
                    console.error(e);
                });
            }
        };
        modal.prototype.attached = function () {
               
        };

        modal.prototype.ok = function () {
            var self = this;

            if (self.header() == "Processing...")
                return;

            dialog.close(self, { ok: true });
        };
   
        modal.prototype.confirmPayment = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                var self = this;

                self.isReviewAndConfirmEnabled(false);

                var data = {
                    instanceId: window.fileplan.instanceCode,
                    planCode: self.plan.code,
                    additionalUsers: self.plan.peopleInfo - _included_users_
                };

                self.header("Processing...");

                dataProvider.subscription
                .updateSubscription(data)
                .done(function (data) {
                    message.title("Payment Confirmation");
                    message.message("Your subscription is now being updated. Once completed, an invoice will be sent to your email.");
                    message.message2("Thank you.");

                    self.header("Done. Thank You");

                    setTimeout(function () {
                        //try {
                        //    window.close();
                        //} catch (ex) { }

                        //dialog.close(self, { ok: true });

                        //router.navigate("#message");

                        dialog.close(self, { ok: true });

                        if (sessionStorage.navto) {
                            //router.navigate("#" + sessionStorage.navto);

                            // must reload
                            window.location.hash = "#" + sessionStorage.navto;
                            window.location.reload();
                        }

                        sessionStorage.removeItem("navto");
                    }, 2000);
                })
                .fail(function (e) {
                    self.isReviewAndConfirmEnabled(true);
                    self.header("Review and Confirm");

                    console.error(e);
                })
                .always(function () {
                    setTimeout(function () {
                        complete();
                    }, 2000);
                });
            }
        });

        return modal;
    }
);
